(function() {
    function init(root) {
    if (!root || root.dataset.cpSpiceBound === 'true') return;
    root.dataset.cpSpiceBound = 'true';
    var isStreetTech = root.classList.contains('cp-spice-collection--bold-street-tech');
    var productGrid = root.querySelector('.cp-spice-grid');
    var infiniteTrigger = root.querySelector('[data-cp-infinite]');
    var pushSoldoutDown = root.getAttribute('data-push-soldout-down') === 'true';
    var mobileZoomObserver = null;
    var cpSpiceAddToCartLabel = root.getAttribute('data-add-to-cart-label') || 'Add to cart';
    var productDetailsFallback = root.getAttribute('data-product-details-fallback') || '';
    var deferredOptionsCache = new Map();

    function fetchDeferredOptions(button) {
      var url = button && button.getAttribute('data-spice-options-url');
      if (!url) return Promise.reject(new Error('Options URL missing'));
      if (!deferredOptionsCache.has(url)) {
        deferredOptionsCache.set(url, fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then(function(response) {
            if (!response.ok) throw new Error('Unable to load options');
            return response.text();
          })
          .catch(function(error) {
            deferredOptionsCache.delete(url);
            throw error;
          }));
      }
      return deferredOptionsCache.get(url);
    }

    function applyCardSelection(card, winner) {
      var buttons = card.querySelectorAll('[data-spice-options-url]');
      if (!buttons.length) return;
      Array.prototype.forEach.call(buttons, function(button) {
        var pickerLabel = button.getAttribute('data-picker-label') || 'Select options';
        var selectedLabel = button.getAttribute('data-selected-label') || cpSpiceAddToCartLabel;
        var nextLabel = winner ? selectedLabel : pickerLabel;
        button.setAttribute('data-open-variant-picker', winner ? 'false' : 'true');
        button.setAttribute('data-variant-selected', winner ? 'true' : 'false');
        button.setAttribute('data-variant-id', winner ? String(winner.id) : '');
        button.setAttribute('data-default-label', nextLabel);
        if (!button.classList.contains('is-working')) setButtonState(button, nextLabel);
      });
      var price = card.querySelector('[data-card-price], .cp-spice-card__street-tech-price');
      var image = card.querySelector('.cp-spice-card__media-slide.is-active');
      if (!winner) {
        if (price && price.dataset.cardOptionsOriginalHtml) price.innerHTML = price.dataset.cardOptionsOriginalHtml;
        if (image && image.dataset.cardOptionsOriginalSrc) { image.src = image.dataset.cardOptionsOriginalSrc; image.alt = image.dataset.cardOptionsOriginalAlt || image.alt; }
        return;
      }
      if (price && !price.dataset.cardOptionsOriginalHtml) price.dataset.cardOptionsOriginalHtml = price.innerHTML;
      if (image && !image.dataset.cardOptionsOriginalSrc) { image.dataset.cardOptionsOriginalSrc = image.currentSrc || image.src; image.dataset.cardOptionsOriginalAlt = image.alt; }
      if (price) price.innerHTML = winner.compareAtPrice ? '<span class="cp-spice-card__price-compare"><s>' + winner.compareAtPrice + '</s></span><span class="cp-spice-card__price-current">' + winner.price + '</span>' : '<span class="cp-spice-card__price-current">' + winner.price + '</span>';
      if (image && winner.image) { image.src = winner.image; image.removeAttribute('srcset'); image.alt = winner.alt || image.alt; }
    }

    function setupCardOptions(card, rootOptions) {
      var variants = JSON.parse(rootOptions.querySelector('[data-card-options-variants]').textContent);
      var selected = [];
      var groups = Array.prototype.slice.call(rootOptions.querySelectorAll('[data-card-option-group]'));
      function resolve() {
        var winner = variants.find(function(variant) { return selected.length === variant.key.length && selected.every(function(value, index) { return value && variant.key[index] === value; }); });
        applyCardSelection(card, winner || null);
      }
      function refresh() {
        groups.forEach(function(group, index) {
          group.querySelectorAll('[data-card-select-value]').forEach(function(choice) {
            var value = choice.dataset.value;
            var eligible = variants.some(function(variant) { return variant.key[index] === value && selected.every(function(entry, position) { return position === index || !entry || variant.key[position] === entry; }); });
            choice.disabled = !eligible;
            choice.setAttribute('aria-pressed', String(selected[index] === value));
          });
          var current = group.querySelector('[data-card-select-current]');
          if (current) current.textContent = selected[index] || 'Choose…';
        });
        resolve();
        if (isStreetTech && card.classList.contains('is-variant-open')) updateStreetTechDrawerHeight(card, 'variant');
      }
      rootOptions._cpSelected = selected;
      rootOptions._cpRefresh = refresh;
      if (isStreetTech && window.ResizeObserver) {
        new ResizeObserver(function() {
          if (card.classList.contains('is-variant-open')) updateStreetTechDrawerHeight(card, 'variant');
        }).observe(rootOptions);
      }
      rootOptions.addEventListener('change', function(event) {
        if (!event.target.matches('[data-card-option-value]')) return;
        var winner = variants.find(function(variant) { return variant.key[0] === event.target.value; });
        applyCardSelection(card, winner || null);
      });
      rootOptions.addEventListener('click', function(event) {
        var trigger = event.target.closest('[data-card-select-trigger]');
        if (trigger) {
          var list = trigger.parentElement.querySelector('[data-card-select-list]');
          var opening = list.hidden;
          rootOptions.querySelectorAll('[data-card-select-list]').forEach(function(other) { other.hidden = true; other.previousElementSibling.setAttribute('aria-expanded', 'false'); });
          list.hidden = !opening; trigger.setAttribute('aria-expanded', String(opening));
          if (isStreetTech) updateStreetTechDrawerHeight(card, 'variant');
          if (opening) {
            var pressed = list.querySelector('[aria-pressed="true"]');
            if (pressed) list.scrollTop = Math.max(0, pressed.offsetTop - list.clientHeight / 2);
            try { list.scrollIntoView({ block: 'nearest' }); } catch (scrollError) {}
          }
          return;
        }
        var choice = event.target.closest('[data-card-select-value]');
        if (!choice || choice.disabled) return;
        var group = choice.closest('[data-card-option-group]');
        var changedIndex = Number(group.dataset.optionIndex);
        selected[changedIndex] = choice.dataset.value;
        for (var i = changedIndex + 1; i < selected.length; i++) {
          if (selected[i] && !variants.some(function(variant) { return selected.slice(0, i + 1).every(function(value, position) { return !value || variant.key[position] === value; }); })) selected[i] = null;
        }
        var list = choice.closest('[data-card-select-list]');
        list.hidden = true; group.querySelector('[data-card-select-trigger]').setAttribute('aria-expanded', 'false');
        refresh();
      });
      refresh();
    }

    function resetCardOptions(card) {
      var rootOptions = card && card.querySelector('[data-card-options]');
      if (!rootOptions) return;
      rootOptions.querySelectorAll('[data-card-option-value]').forEach(function(input) { input.checked = false; });
      if (rootOptions._cpSelected) rootOptions._cpSelected.fill(null);
      rootOptions.querySelectorAll('[data-card-select-list]').forEach(function(list) { list.hidden = true; });
      rootOptions.querySelectorAll('[data-card-select-trigger]').forEach(function(trigger) { trigger.setAttribute('aria-expanded', 'false'); });
      if (rootOptions._cpRefresh) rootOptions._cpRefresh(); else applyCardSelection(card, null);
    }

    async function hydrateCardOptions(button, card) {
      var target = card && card.querySelector('[data-deferred-variant-options]');
      if (!target || target.getAttribute('data-options-status') === 'ready') return;
      target.setAttribute('data-options-status', 'loading');
      try {
        var parser = document.createElement('div');
        parser.innerHTML = await fetchDeferredOptions(button);
        var options = parser.querySelector('[data-card-options]');
        if (!options) throw new Error('Options unavailable');
        var drawer = card.querySelector('[data-variant-drawer]');
        options.querySelectorAll('[id]').forEach(function(node) {
          var oldId = node.id; node.id = drawer.id + '-' + oldId;
          options.querySelectorAll('[for="' + oldId + '"], [aria-controls="' + oldId + '"]').forEach(function(ref) { if (ref.hasAttribute('for')) ref.setAttribute('for', node.id); else ref.setAttribute('aria-controls', node.id); });
        });
        target.replaceChildren(options); target.setAttribute('data-options-status', 'ready');
        setupCardOptions(card, options);
        var first = options.querySelector('input:not(:disabled), [data-card-select-trigger]');
        if (first && card.classList.contains('is-variant-open')) first.focus({ preventScroll: true });
        if (isStreetTech && card.classList.contains('is-variant-open')) updateStreetTechDrawerHeight(card, 'variant');
      } catch (error) {
        target.setAttribute('data-options-status', 'error');
        target.innerHTML = '<p class="cp-product-card-variants__error" role="alert">' + escapeHtml(error.message) + '</p>';
      }
    }

    function setButtonState(btn, text) {
      var label = btn.querySelector('.cp-spice-card__cta-label');
      if (label) label.textContent = text;
    }

    function getGridCardSortOrder(card, fallbackIndex) {
      if (!card) return fallbackIndex;
      var order = window.getComputedStyle(card).getPropertyValue('--cp-spice-card-sort-order') ||
        card.getAttribute('data-cp-grid-order') ||
        fallbackIndex;
      order = parseInt(order, 10);
      return isFinite(order) ? order : fallbackIndex;
    }

    function pushSoldOutProductsDown() {
      if (!pushSoldoutDown || !productGrid) return;

      var gridCards = Array.prototype.slice.call(productGrid.querySelectorAll('[data-cp-grid-card]'));
      if (gridCards.length < 2) return;

      gridCards.sort(function(cardA, cardB) {
        return getGridCardSortOrder(cardA, 0) - getGridCardSortOrder(cardB, 0);
      });

      var activeElement = document.activeElement;
      for (var i = 0; i < gridCards.length; i++) {
        productGrid.appendChild(gridCards[i]);
      }

      if (activeElement && productGrid.contains(activeElement) && typeof activeElement.focus === 'function') {
        try {
          activeElement.focus({ preventScroll: true });
        } catch (error) {
          activeElement.focus();
        }
      }
    }

    function updateStreetTechMobileZoomObserver() {
      if (!isStreetTech || !('IntersectionObserver' in window)) return;

      var isMobile = window.innerWidth <= 767;
      if (!isMobile) {
        if (mobileZoomObserver) {
          mobileZoomObserver.disconnect();
          mobileZoomObserver = null;
        }
        var activeCards = root.querySelectorAll('.cp-spice-card.is-mobile-in-view');
        for (var a = 0; a < activeCards.length; a++) {
          activeCards[a].classList.remove('is-mobile-in-view');
        }
        return;
      }

      if (!mobileZoomObserver) {
        mobileZoomObserver = new IntersectionObserver(function(entries) {
          for (var e = 0; e < entries.length; e++) {
            var entry = entries[e];
            var isFullyVisible = entry.isIntersecting && entry.intersectionRatio >= 0.999;
            entry.target.classList.toggle('is-mobile-in-view', isFullyVisible);
          }
        }, {
          root: null,
          threshold: [1]
        });
      }

      var cardsToObserve = root.querySelectorAll('.cp-spice-card');
      for (var c = 0; c < cardsToObserve.length; c++) {
        mobileZoomObserver.observe(cardsToObserve[c]);
      }
    }

    function openCartDrawer() {
      if (window.theme && window.theme.cart && typeof window.theme.cart.refresh === 'function') {
        window.theme.cart.refresh();
      }

      document.dispatchEvent(new CustomEvent('cart:refresh'));
      window.dispatchEvent(new CustomEvent('cart:updated'));

      if (window.jQuery) {
        window.jQuery(document).trigger('cart.requestComplete');
      }

      window.setTimeout(function() {
        var drawer = document.querySelector('#t4s-mini_cart, [data-drawer-cart], .drawer--cart, #CartDrawer, .cart-drawer');
        var isOpen = !!(drawer && (
          drawer.classList.contains('is--opend') ||
          drawer.classList.contains('is-open') ||
          drawer.classList.contains('active') ||
          drawer.classList.contains('drawer--is-open') ||
          drawer.getAttribute('aria-hidden') === 'false'
        ));
        if (isOpen) return;

        var drawerToggle = document.querySelector('[data-drawer-options*="#t4s-mini_cart"], .header__cart-toggle, [data-cart-toggle], .cart-link, a[href="/cart"]');
        if (!drawerToggle) return;

        if (window.jQuery) {
          window.jQuery(drawerToggle).trigger('click.drawer');
        } else {
          drawerToggle.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
        }
      }, 80);
    }

    function initMediaGallery(media) {
      if (!media || media.dataset.mediaInit === 'true') return;

      var slides = media.querySelectorAll('.cp-spice-card__media-slide');
      if (!slides || slides.length < 2) return;

      media.dataset.mediaInit = 'true';

      var link = media.querySelector('.cp-spice-card__media-link');
      var prevButtons = media.querySelectorAll('[data-media-prev]');
      var nextButtons = media.querySelectorAll('[data-media-next]');
      var prevPreview = media.querySelector('.cp-spice-card__media-nav--prev .cp-spice-card__media-nav-preview');
      var nextPreview = media.querySelector('.cp-spice-card__media-nav--next .cp-spice-card__media-nav-preview');
      var index = 0;
      var startX = 0;
      var startY = 0;
      var deltaX = 0;
      var deltaY = 0;
      var isTracking = false;
      var swipeLocked = false;
      var activePointerId = null;
      var suppressClickUntil = 0;
      var controlsVisibilityTimer = null;

      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-active')) {
          index = i;
          break;
        }
      }

      function getWrappedIndex(value) {
        return (value + slides.length) % slides.length;
      }

      function updateNavPreviews() {
        if (!prevPreview && !nextPreview) return;

        var prevIndex = getWrappedIndex(index - 1);
        var nextIndex = getWrappedIndex(index + 1);
        var prevSrc = slides[prevIndex].getAttribute('data-preview-src');
        var nextSrc = slides[nextIndex].getAttribute('data-preview-src');

        if (prevPreview && prevSrc) prevPreview.src = prevSrc;
        if (nextPreview && nextSrc) nextPreview.src = nextSrc;
      }

      function setIndex(nextIndex) {
        index = getWrappedIndex(nextIndex);

        for (var j = 0; j < slides.length; j++) {
          slides[j].classList.toggle('is-active', j === index);
        }

        updateNavPreviews();
      }

      media.cpSpiceSetByMediaId = function(mediaId) {
        if (!mediaId) return;
        for (var k = 0; k < slides.length; k++) {
          if ((slides[k].getAttribute('data-media-id') || '') === String(mediaId)) {
            setIndex(k);
            break;
          }
        }
      };

      function step(direction) {
        setIndex(index + direction);
      }

      function showMobileControls() {
        if (window.innerWidth > 767) return;
        media.classList.add('is-controls-visible');
        if (controlsVisibilityTimer) {
          window.clearTimeout(controlsVisibilityTimer);
        }
        controlsVisibilityTimer = window.setTimeout(function() {
          media.classList.remove('is-controls-visible');
          controlsVisibilityTimer = null;
        }, 1600);
      }

      function handleGalleryClick(event, direction) {
        event.preventDefault();
        event.stopPropagation();
        showMobileControls();
        step(direction);
      }

      function bindDirection(buttons, direction) {
        for (var b = 0; b < buttons.length; b++) {
          buttons[b].addEventListener('click', function(event) {
            handleGalleryClick(event, direction);
          });
        }
      }

      bindDirection(prevButtons, -1);
      bindDirection(nextButtons, 1);

      function resetGesture() {
        isTracking = false;
        swipeLocked = false;
        deltaX = 0;
        deltaY = 0;
        if (link) link.classList.remove('is-dragging');
      }

      function beginGesture(x, y) {
        startX = x;
        startY = y;
        deltaX = 0;
        deltaY = 0;
        isTracking = true;
        swipeLocked = false;
        if (link) link.classList.add('is-dragging');
        showMobileControls();
      }

      function trackGesture(x, y, event) {
        if (!isTracking) return;

        deltaX = x - startX;
        deltaY = y - startY;

        if (!swipeLocked) {
          if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > 8) {
            swipeLocked = true;
          } else if (Math.abs(deltaY) > Math.abs(deltaX) && Math.abs(deltaY) > 10) {
            resetGesture();
            return;
          }
        }

        if (swipeLocked && event && event.cancelable) {
          event.preventDefault();
        }
      }

      function endGesture() {
        if (!swipeLocked) {
          resetGesture();
          return;
        }

        if (Math.abs(deltaX) > 22) {
          step(deltaX < 0 ? 1 : -1);
          suppressClickUntil = Date.now() + 550;
        }

        resetGesture();
      }

      if (link) {
        link.addEventListener('dragstart', function(event) {
          event.preventDefault();
        });

        if (window.PointerEvent) {
          link.addEventListener('pointerdown', function(event) {
            if (event.pointerType === 'mouse' && event.button !== 0) return;
            activePointerId = event.pointerId;
            try { link.setPointerCapture(event.pointerId); } catch (e) {}
            beginGesture(event.clientX, event.clientY);
          });

          link.addEventListener('pointermove', function(event) {
            if (!isTracking || activePointerId !== event.pointerId) return;
            trackGesture(event.clientX, event.clientY, event);
          });

          link.addEventListener('pointerup', function(event) {
            if (activePointerId !== event.pointerId) return;
            endGesture();
            try { link.releasePointerCapture(event.pointerId); } catch (e) {}
            activePointerId = null;
          });

          link.addEventListener('pointercancel', function(event) {
            if (activePointerId !== event.pointerId) return;
            resetGesture();
            try { link.releasePointerCapture(event.pointerId); } catch (e) {}
            activePointerId = null;
          });
        } else {
          link.addEventListener('touchstart', function(event) {
            if (!event.touches || event.touches.length !== 1) return;
            beginGesture(event.touches[0].clientX, event.touches[0].clientY);
          }, { passive: true });

          link.addEventListener('touchmove', function(event) {
            if (!event.touches || event.touches.length !== 1) return;
            trackGesture(event.touches[0].clientX, event.touches[0].clientY, event);
          }, { passive: false });

          link.addEventListener('touchend', function() {
            endGesture();
          }, { passive: true });

          link.addEventListener('touchcancel', function() {
            resetGesture();
          }, { passive: true });
        }

        link.addEventListener('click', function(event) {
          if (Date.now() < suppressClickUntil) {
            event.preventDefault();
            event.stopPropagation();
          }
        });
      }

      updateNavPreviews();
    }

    var galleries = root.querySelectorAll('.cp-spice-card__media.has-gallery');
    for (var g = 0; g < galleries.length; g++) {
      initMediaGallery(galleries[g]);
    }

    function setCardMediaByVariant(card, mediaId) {
      if (!card || !mediaId) return;

      var media = card.querySelector('.cp-spice-card__media');
      if (!media) return;

      if (typeof media.cpSpiceSetByMediaId === 'function') {
        media.cpSpiceSetByMediaId(mediaId);
        return;
      }

      var slides = media.querySelectorAll('.cp-spice-card__media-slide');
      if (!slides || !slides.length) return;

      var targetIndex = -1;
      for (var i = 0; i < slides.length; i++) {
        if ((slides[i].getAttribute('data-media-id') || '') === String(mediaId)) {
          targetIndex = i;
          break;
        }
      }
      if (targetIndex < 0) return;

      for (var j = 0; j < slides.length; j++) {
        slides[j].classList.toggle('is-active', j === targetIndex);
      }
    }

    function previewVariantMedia(option) {
      if (!option) return;
      var previewCard = option.closest('.cp-spice-card');
      if (!previewCard) return;
      var previewMediaId = option.getAttribute('data-variant-media-id');
      if (!previewMediaId) return;
      setCardMediaByVariant(previewCard, previewMediaId);
    }

    function restoreSelectedVariantMedia(card) {
      if (!card) return;
      var drawer = card.querySelector('[data-variant-drawer]');
      if (!drawer) return;
      var selectedOption = drawer.querySelector('[data-variant-option].is-selected') ||
        drawer.querySelector('[data-variant-option][aria-pressed="true"]');
      if (selectedOption) {
        previewVariantMedia(selectedOption);
        return;
      }

      var defaultMediaId = card.getAttribute('data-default-media-id');
      if (defaultMediaId) {
        setCardMediaByVariant(card, defaultMediaId);
        return;
      }

      var fallbackOption = drawer.querySelector('[data-variant-option][data-variant-available="true"]') ||
        drawer.querySelector('[data-variant-option]');
      if (!fallbackOption) return;
      previewVariantMedia(fallbackOption);
    }

    function resetStreetTechVariantPicker(card, restoreMedia) {
      if (!isStreetTech || !card || card.querySelector('[data-spice-options-url]')) return;
      restoreMedia = !!restoreMedia;

      var drawer = card.querySelector('[data-variant-drawer]');
      if (!drawer) return;

      var options = drawer.querySelectorAll('[data-variant-option]');
      for (var i = 0; i < options.length; i++) {
        options[i].classList.remove('is-selected');
        options[i].setAttribute('aria-pressed', 'false');
      }

      var streetTechAddBtn = card.querySelector('.cp-spice-card__street-tech-add[data-selected-label]');
      if (streetTechAddBtn) {
        var pickerLabel = streetTechAddBtn.getAttribute('data-picker-label') || streetTechAddBtn.getAttribute('data-default-label') || '';
        streetTechAddBtn.setAttribute('data-default-label', pickerLabel);
        streetTechAddBtn.setAttribute('data-open-variant-picker', 'true');
        streetTechAddBtn.setAttribute('data-variant-selected', 'false');
        streetTechAddBtn.setAttribute('data-variant-id', '');
        streetTechAddBtn.disabled = false;
        streetTechAddBtn.classList.remove('is-disabled');
        streetTechAddBtn.classList.remove('is-working');
        setButtonState(streetTechAddBtn, pickerLabel);
      }

      if (restoreMedia) {
        restoreSelectedVariantMedia(card);
      }
    }

    function setInfoToggleLabel(toggle, text) {
      if (!toggle) return;
      var label = toggle.querySelector('[data-info-toggle-label]');
      if (label) label.textContent = text;
    }

    function normalizeText(value) {
      return String(value || '').replace(/\s+/g, ' ').trim();
    }

    function escapeHtml(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    var textMeasureCanvas = document.createElement('canvas');
    var textMeasureContext = textMeasureCanvas.getContext('2d');

    function measureTextWidth(text, styles) {
      if (!text || !styles || !textMeasureContext) return 0;

      var fontValue = styles.font;
      if (!fontValue || fontValue === '') {
        var lineHeight = styles.lineHeight && styles.lineHeight !== 'normal' ? ('/' + styles.lineHeight) : '';
        fontValue = [
          styles.fontStyle || 'normal',
          styles.fontVariant || 'normal',
          styles.fontWeight || '400',
          (styles.fontSize || '16px') + lineHeight,
          styles.fontFamily || 'sans-serif'
        ].join(' ');
      }

      textMeasureContext.font = fontValue;
      var measured = textMeasureContext.measureText(text).width;
      var letterSpacing = parseFloat(styles.letterSpacing);
      if (isFinite(letterSpacing) && letterSpacing !== 0 && text.length > 1) {
        measured += letterSpacing * (text.length - 1);
      }

      return measured;
    }

    function syncStreetTechCardCopy(card) {
      if (!isStreetTech || !card) return;

      var metaRow = card.querySelector('.cp-spice-card__meta-row');
      var title = card.querySelector('.cp-spice-card__title');
      var titleText = card.querySelector('.cp-spice-card__title a');
      var desc = card.querySelector('.cp-spice-card__desc--street-tech');
      if (!title || !titleText || !desc) return;

      var titleStyles = window.getComputedStyle(titleText);
      var lineHeight = parseFloat(titleStyles.lineHeight);
      if (!lineHeight || !isFinite(lineHeight)) {
        var fallbackFontSize = parseFloat(titleStyles.fontSize);
        lineHeight = (fallbackFontSize && isFinite(fallbackFontSize)) ? (fallbackFontSize * 1.02) : 0;
      }
      if (!lineHeight) return;

      var titleHeight = titleText.getBoundingClientRect().height;
      var renderedLines = Math.max(1, Math.round(titleHeight / lineHeight));
      var isSingleLineTitle = renderedLines <= 1;
      var titleCopy = normalizeText(titleText.textContent || title.textContent || '');
      var metaRowWidth = metaRow ? metaRow.getBoundingClientRect().width : 0;
      var measuredTitleWidth = measureTextWidth(titleCopy, titleStyles);
      var isCompactTitle = renderedLines <= 1 && metaRowWidth > 0 && measuredTitleWidth <= (metaRowWidth * 0.66);
      var comparePrice = card.querySelector('.cp-spice-card__meta-row .cp-spice-card__price-compare, .cp-spice-card__street-tech-price .cp-spice-card__price-compare');
      var hasComparePrice = false;
      if (comparePrice && normalizeText(comparePrice.textContent || '')) {
        var compareStyles = window.getComputedStyle(comparePrice);
        hasComparePrice = compareStyles.display !== 'none' && compareStyles.visibility !== 'hidden';
      }

      var snippetLines = 5 - Math.max(0, renderedLines - 1);
      if (hasComparePrice) snippetLines -= 1;
      snippetLines = Math.max(2, Math.min(5, snippetLines));
      card.style.setProperty('--cp-street-tech-snippet-lines', String(snippetLines));

      card.classList.toggle('is-title-single-line', isSingleLineTitle);
      card.classList.toggle('is-title-two-line', !isSingleLineTitle);
      card.classList.toggle('is-title-compact', isCompactTitle);
    }

    function syncStreetTechCopyLayout(scope) {
      if (!isStreetTech) return;
      var source = scope || root;
      if (!source) return;
      var streetTechCards = source.querySelectorAll('.cp-spice-card');
      for (var i = 0; i < streetTechCards.length; i++) {
        syncStreetTechCardCopy(streetTechCards[i]);
      }
    }

    var videoFeatureHeightFrame = null;

    function getVideoFeatureReferenceCards(featureCard) {
      var referenceCards = [];
      var sibling = featureCard ? featureCard.previousElementSibling : null;

      while (sibling && referenceCards.length < 2) {
        if (sibling.classList && sibling.classList.contains('cp-spice-card') && !sibling.classList.contains('cp-spice-card--video-feature')) {
          referenceCards.push(sibling);
        }
        sibling = sibling.previousElementSibling;
      }

      sibling = featureCard ? featureCard.nextElementSibling : null;
      while (sibling && referenceCards.length < 2) {
        if (sibling.classList && sibling.classList.contains('cp-spice-card') && !sibling.classList.contains('cp-spice-card--video-feature')) {
          referenceCards.push(sibling);
        }
        sibling = sibling.nextElementSibling;
      }

      return referenceCards;
    }

    function syncVideoFeatureCardHeights() {
      videoFeatureHeightFrame = null;
      if (!isStreetTech || !productGrid) return;

      var featureCards = productGrid.querySelectorAll('.cp-spice-card--video-feature');
      if (!featureCards.length) return;

      for (var i = 0; i < featureCards.length; i++) {
        featureCards[i].classList.remove('is-height-matched');
        featureCards[i].style.removeProperty('--cp-spice-video-feature-height');
      }

      if (window.innerWidth <= 767) return;

      for (var f = 0; f < featureCards.length; f++) {
        var featureCard = featureCards[f];
        var referenceCards = getVideoFeatureReferenceCards(featureCard);
        var referenceHeight = 0;

        for (var r = 0; r < referenceCards.length; r++) {
          referenceHeight = Math.max(referenceHeight, Math.ceil(referenceCards[r].getBoundingClientRect().height));
        }

        if (referenceHeight > 0) {
          featureCard.style.setProperty('--cp-spice-video-feature-height', referenceHeight + 'px');
          featureCard.classList.add('is-height-matched');
        }
      }
    }

    function queueVideoFeatureHeightSync() {
      if (!isStreetTech || !productGrid) return;
      if (videoFeatureHeightFrame) window.cancelAnimationFrame(videoFeatureHeightFrame);
      videoFeatureHeightFrame = window.requestAnimationFrame(syncVideoFeatureCardHeights);
    }

    function watchVideoFeatureMediaLoads(scope) {
      if (!isStreetTech) return;
      var source = scope || root;
      var media = source.querySelectorAll('.cp-spice-card img, .cp-spice-card video');
      for (var i = 0; i < media.length; i++) {
        if (media[i].dataset.cpSpiceFeatureMeasureBound === 'true') continue;
        media[i].dataset.cpSpiceFeatureMeasureBound = 'true';
        media[i].addEventListener('load', queueVideoFeatureHeightSync, { once: true });
        media[i].addEventListener('loadedmetadata', queueVideoFeatureHeightSync, { once: true });
      }
    }

    function trimLeadingEmptyBlocks(container) {
      if (!container) return;
      while (container.children && container.children.length) {
        var first = container.children[0];
        if (!first) break;
        var firstText = normalizeText(first.textContent || '');
        if (firstText) break;
        first.remove();
      }
    }

    function measureStreetTechDrawerHeight(drawer, maxViewportRatio, minHeight) {
      if (!drawer) return 0;
      maxViewportRatio = maxViewportRatio || 0.56;
      minHeight = typeof minHeight === 'number' ? minHeight : 120;
      var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 900;
      var maxHeight = Math.max(minHeight, Math.round(viewportHeight * maxViewportRatio));
      var previousHeight = drawer.style.height;
      var previousMaxHeight = drawer.style.maxHeight;
      var previousPaddingTop = drawer.style.paddingTop;
      var previousPaddingBottom = drawer.style.paddingBottom;
      var previousOverflowY = drawer.style.overflowY;

      drawer.style.height = 'auto';
      drawer.style.maxHeight = 'none';
      drawer.style.paddingTop = '12px';
      drawer.style.paddingBottom = '12px';
      drawer.style.overflowY = 'visible';

      var measured = Math.ceil(drawer.scrollHeight);

      drawer.style.height = previousHeight;
      drawer.style.maxHeight = previousMaxHeight;
      drawer.style.paddingTop = previousPaddingTop;
      drawer.style.paddingBottom = previousPaddingBottom;
      drawer.style.overflowY = previousOverflowY;

      return Math.max(minHeight, Math.min(measured, maxHeight));
    }

    function syncCardOptionsPull(card) {
      if (!card) return;
      var anchor = card.querySelector('.cp-spice-card__desc--street-tech') || card.querySelector('.cp-spice-card__meta-row');
      if (!anchor || card.classList.contains('cp-spice-card--video-feature')) {
        card.style.removeProperty('--cp-card-options-pull');
        return;
      }
      var freeSpace = card.getBoundingClientRect().bottom - anchor.getBoundingClientRect().bottom;
      card.style.setProperty('--cp-card-options-pull', Math.max(0, Math.round(freeSpace - 12)) + 'px');
    }

    function updateStreetTechDrawerHeight(card, mode) {
      if (!isStreetTech || !card) return;
      var drawerSelector = mode === 'variant' ? '[data-variant-drawer]' : '[data-info-drawer]';
      var targetVar = mode === 'variant' ? '--cp-street-tech-open-variant-h' : '--cp-street-tech-open-info-h';
      var ratio = mode === 'variant' ? 0.6 : 0.56;
      var drawer = card.querySelector(drawerSelector);
      if (!drawer || drawer.hidden) return;
      var isCardOptionsDrawer = mode === 'variant' && drawer.classList.contains('cp-spice-card__variant-drawer--pdp');
      if (isCardOptionsDrawer) syncCardOptionsPull(card);
      var targetHeight = measureStreetTechDrawerHeight(drawer, ratio, isCardOptionsDrawer ? 48 : 120);
      if (targetHeight > 0) {
        card.style.setProperty(targetVar, targetHeight + 'px');
      }
    }

    function refreshStreetTechOpenHeights(scope) {
      if (!isStreetTech) return;
      var source = scope || root;
      if (!source) return;
      var openInfoCards = source.querySelectorAll('.cp-spice-card.is-info-open');
      for (var i = 0; i < openInfoCards.length; i++) {
        updateStreetTechDrawerHeight(openInfoCards[i], 'info');
      }
      var openVariantCards = source.querySelectorAll('.cp-spice-card.is-variant-open');
      for (var j = 0; j < openVariantCards.length; j++) {
        updateStreetTechDrawerHeight(openVariantCards[j], 'variant');
      }
    }

    function revealFeatureInfoDrawer(card, drawer) {
      if (!isStreetTech || !card || !drawer || !card.classList.contains('cp-spice-card--video-feature')) return;

      window.requestAnimationFrame(function() {
        var actions = card.querySelector('.cp-spice-card__street-tech-actions');
        var target = actions || drawer;
        if (!target) return;

        var targetRect = target.getBoundingClientRect();
        var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
        if (!viewportHeight) return;

        var margin = 18;
        var bottomDelta = targetRect.bottom - (viewportHeight - margin);
        var topDelta = targetRect.top - margin;
        var scrollDelta = 0;

        if (bottomDelta > 0) {
          scrollDelta = bottomDelta;
        } else if (topDelta < 0) {
          scrollDelta = topDelta;
        }

        if (Math.abs(scrollDelta) < 2) return;

        try {
          window.scrollBy({ top: scrollDelta, left: 0, behavior: 'smooth' });
        } catch (error) {
          window.scrollBy(0, scrollDelta);
        }
      });
    }

    function syncInfoActiveState() {
      var hasOpen = root.querySelector('.cp-spice-card.is-info-open, .cp-spice-card.is-variant-open') !== null;
      root.classList.toggle('is-info-active', hasOpen);
    }

    function hideDrawerAfterTransition(card, drawer, openClass) {
      var hideDrawer = function(event) {
        if (event && event.target !== drawer) return;
        if (!card.classList.contains(openClass)) {
          drawer.hidden = true;
        }
        drawer.removeEventListener('transitionend', hideDrawer);
      };

      drawer.addEventListener('transitionend', hideDrawer);
      window.setTimeout(function() {
        hideDrawer();
      }, 360);
    }

    function setInfoState(card, isOpen) {
      if (!card) return;

      var drawer = card.querySelector('[data-info-drawer]');
      var toggle = card.querySelector('[data-info-toggle]');
      if (!drawer || !toggle) return;
      var isStreetTechToggle = toggle.classList.contains('cp-spice-card__street-tech-info');

      if (isOpen) {
        if (card.classList.contains('is-variant-open')) {
          setVariantState(card, false);
        }
        drawer.hidden = false;
        var infoTextNode = drawer.querySelector('.cp-spice-card__info-text');
        var infoFallback = drawer.getAttribute('data-info-fallback') || '';
        if (infoTextNode && !normalizeText(infoTextNode.textContent || '')) {
          infoTextNode.innerHTML = '<p>' + escapeHtml(infoFallback || productDetailsFallback) + '</p>';
        }
        if (infoTextNode) {
          if (isStreetTech) trimLeadingEmptyBlocks(infoTextNode);
          var blockCount = infoTextNode.children ? infoTextNode.children.length : 0;
          infoTextNode.classList.toggle('is-continuation', blockCount > 1);
        }
        if (isStreetTech) {
          updateStreetTechDrawerHeight(card, 'info');
        }
        card.classList.add('is-info-open');
        toggle.setAttribute('aria-expanded', 'true');
        setInfoToggleLabel(toggle, 'X');
        syncInfoActiveState();
        revealFeatureInfoDrawer(card, drawer);
        return;
      }

      card.classList.remove('is-info-open');
      toggle.setAttribute('aria-expanded', 'false');
      var infoLabel = isStreetTechToggle
        ? toggle.getAttribute('data-info-label')
        : toggle.getAttribute('data-more-info-label');
      setInfoToggleLabel(toggle, infoLabel || '');
      if (isStreetTech) {
        card.style.removeProperty('--cp-street-tech-open-info-h');
      }
      syncInfoActiveState();
      hideDrawerAfterTransition(card, drawer, 'is-info-open');
    }

    function setVariantOptionState(card, optionToSelect, preservePickerState) {
      if (!card || !optionToSelect) return;
      preservePickerState = !!preservePickerState;
      var drawer = card.querySelector('[data-variant-drawer]');
      if (!drawer) return;

      var options = drawer.querySelectorAll('[data-variant-option]');
      for (var i = 0; i < options.length; i++) {
        var isSelected = options[i] === optionToSelect;
        options[i].classList.toggle('is-selected', isSelected);
        options[i].setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      }

      var variantId = optionToSelect.getAttribute('data-variant-id');
      var isAvailable = optionToSelect.getAttribute('data-variant-available') === 'true';
      var variantMediaId = optionToSelect.getAttribute('data-variant-media-id');

      var drawerAddBtn = drawer.querySelector('[data-variant-add]');
      var outOfStockLabel = drawerAddBtn ? drawerAddBtn.getAttribute('data-oos-label') : '';
      var targetLabel = isAvailable ? cpSpiceAddToCartLabel : outOfStockLabel;
      if (drawerAddBtn) {
        drawerAddBtn.setAttribute('data-variant-id', variantId || '');
        drawerAddBtn.setAttribute('data-default-label', targetLabel);
        drawerAddBtn.disabled = !isAvailable;
        drawerAddBtn.classList.toggle('is-disabled', !isAvailable);
        setButtonState(drawerAddBtn, targetLabel);
      }

      var cardAddBtns = card.querySelectorAll('.cp-spice-card__cta-side--add[data-open-variant-picker=\"true\"]');
      for (var b = 0; b < cardAddBtns.length; b++) {
        cardAddBtns[b].setAttribute('data-variant-id', variantId || '');
        if (isStreetTech && cardAddBtns[b].classList.contains('cp-spice-card__street-tech-add') && !preservePickerState) {
          var selectedLabel = cardAddBtns[b].getAttribute('data-selected-label') || cpSpiceAddToCartLabel;
          var cardButtonLabel = isAvailable
            ? selectedLabel
            : (cardAddBtns[b].getAttribute('data-oos-label') || outOfStockLabel);
          cardAddBtns[b].setAttribute('data-default-label', cardButtonLabel);
          cardAddBtns[b].setAttribute('data-open-variant-picker', isAvailable ? 'false' : 'true');
          cardAddBtns[b].setAttribute('data-variant-selected', isAvailable ? 'true' : 'false');
          cardAddBtns[b].disabled = false;
          cardAddBtns[b].classList.remove('is-disabled');
          setButtonState(cardAddBtns[b], cardButtonLabel);
        }
      }

      if (variantMediaId) {
        setCardMediaByVariant(card, variantMediaId);
      }
    }

    function initVariantPicker(card) {
      if (!card) return;
      var drawer = card.querySelector('[data-variant-drawer]');
      if (!drawer) return;
      if (isStreetTech) {
        resetStreetTechVariantPicker(card, false);
        return;
      }

      var selected = drawer.querySelector('[data-variant-option].is-selected') ||
        drawer.querySelector('[data-variant-option][data-variant-available=\"true\"]') ||
        drawer.querySelector('[data-variant-option]');
      if (!selected) return;
      setVariantOptionState(card, selected, true);
    }

    function setVariantState(card, isOpen) {
      if (!card) return;

      var drawer = card.querySelector('[data-variant-drawer]');
      if (!drawer) return;

      if (isOpen) {
        if (card.classList.contains('is-info-open')) {
          setInfoState(card, false);
        }
        drawer.hidden = false;
        if (isStreetTech) {
          updateStreetTechDrawerHeight(card, 'variant');
        }
        card.classList.add('is-variant-open');
        card.querySelectorAll('[data-spice-options-url]').forEach(function(button) { button.setAttribute('aria-expanded', 'true'); });
        var deferredButton = card.querySelector('[data-spice-options-url]');
        if (deferredButton) hydrateCardOptions(deferredButton, card);
        initVariantPicker(card);
        if (isStreetTech) {
          updateStreetTechDrawerHeight(card, 'variant');
        }
        syncInfoActiveState();
        return;
      }

      card.classList.remove('is-variant-open');
      card.querySelectorAll('[data-spice-options-url]').forEach(function(button) { button.setAttribute('aria-expanded', 'false'); });
      if (card.querySelector('[data-spice-options-url]')) resetCardOptions(card);
      if (isStreetTech) {
        resetStreetTechVariantPicker(card, true);
        card.style.removeProperty('--cp-street-tech-open-variant-h');
      } else {
        restoreSelectedVariantMedia(card);
      }

      syncInfoActiveState();
      hideDrawerAfterTransition(card, drawer, 'is-variant-open');
    }

    function closeAllOpenCards(exceptCard) {
      var openCards = root.querySelectorAll('.cp-spice-card.is-info-open, .cp-spice-card.is-variant-open');
      for (var o = 0; o < openCards.length; o++) {
        if (openCards[o] === exceptCard) continue;
        if (openCards[o].classList.contains('is-info-open')) setInfoState(openCards[o], false);
        if (openCards[o].classList.contains('is-variant-open')) setVariantState(openCards[o], false);
      }
    }

    async function addVariantToCart(addBtn, variantId) {
      if (!addBtn || !variantId) return false;

      var defaultLabel = addBtn.getAttribute('data-default-label') || cpSpiceAddToCartLabel;
      var parsedVariantId = parseInt(variantId, 10);
      if (!parsedVariantId) {
        setButtonState(addBtn, 'TRY AGAIN');
        window.setTimeout(function() {
          setButtonState(addBtn, defaultLabel);
        }, 1200);
        return false;
      }

      addBtn.disabled = true;
      addBtn.classList.add('is-working');
      setButtonState(addBtn, 'ADDING...');

      var wasAdded = false;
      try {
        var response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ id: parsedVariantId, quantity: 1 })
        });
        if (!response.ok) throw new Error('Cart add failed');

        wasAdded = true;
        setButtonState(addBtn, 'ADDED +');
        document.dispatchEvent(new CustomEvent('cart:item-added', {
          detail: { variant_id: parsedVariantId }
        }));
      } catch (error) {
        setButtonState(addBtn, 'TRY AGAIN');
        return false;
      } finally {
        if (wasAdded) {
          try {
            openCartDrawer();
          } catch (drawerError) {}
        }
        window.setTimeout(function() {
          addBtn.disabled = false;
          addBtn.classList.remove('is-working');
          var resetLabel = addBtn.getAttribute('data-default-label') || defaultLabel;
          setButtonState(addBtn, resetLabel);
        }, 1400);
      }

      return true;
    }

    function bindCard(card) {
      if (!card || card.dataset.cpSpiceCardBound === 'true') return;
      card.dataset.cpSpiceCardBound = 'true';

      if (isStreetTech && !card.getAttribute('data-default-media-id')) {
        var defaultSlide = card.querySelector('.cp-spice-card__media-slide.is-active[data-media-id]') ||
          card.querySelector('.cp-spice-card__media-slide[data-media-id]');
        if (defaultSlide) {
          card.setAttribute('data-default-media-id', defaultSlide.getAttribute('data-media-id') || '');
        }
      }

      if (isStreetTech && mobileZoomObserver && window.innerWidth <= 767) {
        mobileZoomObserver.observe(card);
      }

      initVariantPicker(card);
      syncStreetTechCardCopy(card);
      window.requestAnimationFrame(function() {
        syncStreetTechCardCopy(card);
        refreshStreetTechOpenHeights(card);
      });
    }

    function initCardGalleries(card) {
      if (!card) return;
      var mediaNodes = card.querySelectorAll('.cp-spice-card__media.has-gallery');
      for (var m = 0; m < mediaNodes.length; m++) {
        initMediaGallery(mediaNodes[m]);
      }
    }

    var cards = root.querySelectorAll('.cp-spice-card');
    for (var c = 0; c < cards.length; c++) {
      bindCard(cards[c]);
    }
    pushSoldOutProductsDown();
    updateStreetTechMobileZoomObserver();
    syncStreetTechCopyLayout(root);
    watchVideoFeatureMediaLoads(root);
    queueVideoFeatureHeightSync();
    if (isStreetTech) {
      window.setTimeout(function() {
        syncStreetTechCopyLayout(root);
        refreshStreetTechOpenHeights(root);
        queueVideoFeatureHeightSync();
      }, 220);
    }
    syncInfoActiveState();

    var infiniteObserver = null;
    var isLoadingMore = false;

    async function loadMoreProducts() {
      if (!infiniteTrigger || !productGrid || isLoadingMore) return;

      var nextUrl = infiniteTrigger.getAttribute('data-next-url');
      if (!nextUrl) return;

      isLoadingMore = true;
      infiniteTrigger.classList.add('is-loading');

      try {
        var response = await fetch(nextUrl, {
          method: 'GET',
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Failed to load more products');

        var html = await response.text();
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextRoot = doc.getElementById(root.id);
        if (!nextRoot) throw new Error('Missing collection root on next page');

        var nextGrid = nextRoot.querySelector('.cp-spice-grid');
        if (!nextGrid) throw new Error('Missing collection grid on next page');

        var nextCards = nextGrid.querySelectorAll('.cp-spice-card');
        for (var n = 0; n < nextCards.length; n++) {
          var newCard = nextCards[n].cloneNode(true);
          productGrid.appendChild(newCard);
          initCardGalleries(newCard);
          bindCard(newCard);
          watchVideoFeatureMediaLoads(newCard);
        }
        pushSoldOutProductsDown();
        syncStreetTechCopyLayout(productGrid);
        refreshStreetTechOpenHeights(productGrid);
        queueVideoFeatureHeightSync();

        var nextTrigger = nextRoot.querySelector('[data-cp-infinite]');
        var nextPageUrl = nextTrigger ? (nextTrigger.getAttribute('data-next-url') || '') : '';
        if (nextPageUrl) {
          infiniteTrigger.setAttribute('data-next-url', nextPageUrl);
        } else {
          infiniteTrigger.removeAttribute('data-next-url');
          infiniteTrigger.hidden = true;
          if (infiniteObserver) infiniteObserver.disconnect();
        }
      } catch (error) {
        infiniteTrigger.removeAttribute('data-next-url');
        infiniteTrigger.hidden = true;
        if (infiniteObserver) infiniteObserver.disconnect();
      } finally {
        infiniteTrigger.classList.remove('is-loading');
        isLoadingMore = false;
      }
    }

    if (infiniteTrigger && productGrid && 'IntersectionObserver' in window) {
      infiniteObserver = new IntersectionObserver(function(entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            loadMoreProducts();
            break;
          }
        }
      }, { root: null, rootMargin: '500px 0px', threshold: 0.01 });

      infiniteObserver.observe(infiniteTrigger);
    }

    root.addEventListener('click', async function(event) {
      var infoToggle = event.target.closest('[data-info-toggle]');
      if (infoToggle && root.contains(infoToggle)) {
        event.preventDefault();
        event.stopPropagation();

        var toggleCard = infoToggle.closest('.cp-spice-card');
        if (!toggleCard) return;

        var isCurrentlyOpen = toggleCard.classList.contains('is-info-open');
        closeAllOpenCards(toggleCard);
        setInfoState(toggleCard, !isCurrentlyOpen);
        return;
      }

      var infoClose = event.target.closest('[data-info-close]');
      if (infoClose && root.contains(infoClose)) {
        event.preventDefault();
        event.stopPropagation();

        var closeCard = infoClose.closest('.cp-spice-card');
        if (closeCard) setInfoState(closeCard, false);
        return;
      }

      var variantOption = event.target.closest('[data-variant-option]');
      if (variantOption && root.contains(variantOption)) {
        event.preventDefault();
        event.stopPropagation();
        var optionCard = variantOption.closest('.cp-spice-card');
        if (optionCard) {
          setVariantOptionState(optionCard, variantOption, false);
        }
        return;
      }

      var variantClose = event.target.closest('[data-variant-close]');
      if (variantClose && root.contains(variantClose)) {
        event.preventDefault();
        event.stopPropagation();
        var variantCloseCard = variantClose.closest('.cp-spice-card');
        if (variantCloseCard) {
          setVariantState(variantCloseCard, false);
          if (variantCloseCard.cpVariantOpener) variantCloseCard.cpVariantOpener.focus({ preventScroll: true });
        }
        return;
      }

      var variantAdd = event.target.closest('[data-variant-add]');
      if (variantAdd && root.contains(variantAdd)) {
        event.preventDefault();
        event.stopPropagation();
        if (variantAdd.disabled || variantAdd.classList.contains('is-disabled')) return;

        var variantAddId = variantAdd.getAttribute('data-variant-id');
        if (!variantAddId) return;

        var variantCard = variantAdd.closest('.cp-spice-card');
        var wasAdded = await addVariantToCart(variantAdd, variantAddId);
        if (wasAdded && variantCard) setVariantState(variantCard, false);
        return;
      }

      var addBtn = event.target.closest('.cp-spice-card__cta-side--add');
      if (!addBtn || !root.contains(addBtn)) return;
      if (addBtn.matches('[data-action-atc]')) return;

      event.preventDefault();
      if (addBtn.disabled || addBtn.getAttribute('aria-disabled') === 'true') return;

      var addCard = addBtn.closest('.cp-spice-card');
      var usesVariantPicker = addBtn.getAttribute('data-open-variant-picker') === 'true';
      if (usesVariantPicker && addCard && addCard.querySelector('[data-variant-drawer]')) {
        var shouldOpenVariant = !addCard.classList.contains('is-variant-open');
        if (shouldOpenVariant) addCard.cpVariantOpener = addBtn;
        closeAllOpenCards(addCard);
        setVariantState(addCard, shouldOpenVariant);
        if (!shouldOpenVariant) addBtn.focus({ preventScroll: true });
        return;
      }

      var variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      var addResult = await addVariantToCart(addBtn, variantId);
      if (addResult && addCard && addCard.classList.contains('is-variant-open')) {
        setVariantState(addCard, false);
      }
    });

    root.addEventListener('pointerover', function(event) {
      var button = event.target.closest('[data-spice-options-url]');
      if (button && root.contains(button)) fetchDeferredOptions(button).catch(function() {});
    }, { passive: true });

    root.addEventListener('focusin', function(event) {
      var button = event.target.closest('[data-spice-options-url]');
      if (button && root.contains(button)) fetchDeferredOptions(button).catch(function() {});
    });

    root.addEventListener('mouseover', function(event) {
      var hoveredVariantOption = event.target.closest('[data-variant-option]');
      if (!hoveredVariantOption || !root.contains(hoveredVariantOption)) return;
      previewVariantMedia(hoveredVariantOption);
    });

    root.addEventListener('mouseout', function(event) {
      var exitedCardBoundary = event.target.closest('.cp-spice-card');
      if (exitedCardBoundary && (!event.relatedTarget || !exitedCardBoundary.contains(event.relatedTarget))) {
        var hasOpenInlineList = exitedCardBoundary.querySelector('[data-card-select-list]:not([hidden])');
        var cardOptions = exitedCardBoundary.querySelector('[data-card-options]');
        var hasFocusInside = !!(cardOptions && cardOptions.contains(document.activeElement));
        if (hasOpenInlineList || hasFocusInside) return;
        if (exitedCardBoundary.classList.contains('is-info-open')) setInfoState(exitedCardBoundary, false);
        if (exitedCardBoundary.classList.contains('is-variant-open')) setVariantState(exitedCardBoundary, false);
      }
      var exitedVariantOption = event.target.closest('[data-variant-option]');
      if (!exitedVariantOption || !root.contains(exitedVariantOption)) return;
      var relatedTarget = event.relatedTarget;
      if (relatedTarget && exitedVariantOption.contains(relatedTarget)) return;
      var currentDrawer = exitedVariantOption.closest('[data-variant-drawer]');
      if (currentDrawer && relatedTarget && currentDrawer.contains(relatedTarget)) return;
      var exitedCard = exitedVariantOption.closest('.cp-spice-card');
      restoreSelectedVariantMedia(exitedCard);
    });

    root.addEventListener('focusin', function(event) {
      var focusedVariantOption = event.target.closest('[data-variant-option]');
      if (!focusedVariantOption || !root.contains(focusedVariantOption)) return;
      previewVariantMedia(focusedVariantOption);
    });

    root.addEventListener('focusout', function(event) {
      var blurredVariantOption = event.target.closest('[data-variant-option]');
      if (!blurredVariantOption || !root.contains(blurredVariantOption)) return;
      var relatedTarget = event.relatedTarget;
      if (relatedTarget && blurredVariantOption.contains(relatedTarget)) return;
      var blurredDrawer = blurredVariantOption.closest('[data-variant-drawer]');
      if (blurredDrawer && relatedTarget && blurredDrawer.contains(relatedTarget)) return;
      var blurredCard = blurredVariantOption.closest('.cp-spice-card');
      restoreSelectedVariantMedia(blurredCard);
    });

    document.addEventListener('click', function(event) {
      var outsideOpenVariant = root.querySelector('.cp-spice-card.is-variant-open');
      if (root.contains(event.target)) {
        var openCardInRoot = root.querySelector('.cp-spice-card.is-info-open, .cp-spice-card.is-variant-open');
        if (openCardInRoot && !openCardInRoot.contains(event.target)) {
          closeAllOpenCards(null);
          if (outsideOpenVariant && outsideOpenVariant.cpVariantOpener) outsideOpenVariant.cpVariantOpener.focus({ preventScroll: true });
        }
        return;
      }
      closeAllOpenCards(null);
      if (outsideOpenVariant && outsideOpenVariant.cpVariantOpener) outsideOpenVariant.cpVariantOpener.focus({ preventScroll: true });
    });

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') {
        var escapeCard = root.querySelector('.cp-spice-card.is-variant-open');
        var openList = escapeCard && escapeCard.querySelector('[data-card-select-list]:not([hidden])');
        if (openList) {
          openList.hidden = true;
          var listTrigger = openList.parentElement.querySelector('[data-card-select-trigger]');
          if (listTrigger) { listTrigger.setAttribute('aria-expanded', 'false'); listTrigger.focus({ preventScroll: true }); }
          if (isStreetTech) updateStreetTechDrawerHeight(escapeCard, 'variant');
          return;
        }
        closeAllOpenCards(null);
        if (escapeCard && escapeCard.cpVariantOpener) escapeCard.cpVariantOpener.focus({ preventScroll: true });
      }
    });

    if (isStreetTech) {
      var streetTechResizeTimer = null;
      window.addEventListener('resize', function() {
        if (streetTechResizeTimer) window.clearTimeout(streetTechResizeTimer);
        streetTechResizeTimer = window.setTimeout(function() {
          updateStreetTechMobileZoomObserver();
          syncStreetTechCopyLayout(root);
          refreshStreetTechOpenHeights(root);
          queueVideoFeatureHeightSync();
        }, 120);
      });
    }
    }

    function initAll(scope) {
      var source = scope && scope.querySelectorAll ? scope : document;
      var roots = source.querySelectorAll('[data-cp-spice-collection]');
      for (var i = 0; i < roots.length; i++) init(roots[i]);
      if (source.matches && source.matches('[data-cp-spice-collection]')) init(source);
    }

    initAll(document);
    document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  })();
